import type { Router } from 'vue-router';

/**
 * Launch Handler API — not yet in lib.dom.d.ts (TS 5.9).
 * Chrome delivers the captured link here when the manifest declares
 * `launch_handler.client_mode: "focus-existing"`.
 */
interface LaunchParams {
  targetURL?: string;
}

interface LaunchQueue {
  setConsumer: (consumer: (params: LaunchParams) => void) => void;
}

declare global {
  interface Window {
    launchQueue?: LaunchQueue;
  }
}

/**
 * Routes links captured by the installed PWA into the already-running window.
 *
 * With `client_mode: "focus-existing"` the browser focuses the open app window
 * instead of navigating it, and hands us the target URL — so we have to perform
 * the navigation ourselves. Without a consumer the link would silently do
 * nothing but raise the window.
 */
export const setupLaunchQueue = (router: Router): void => {
  if (!window.launchQueue) {
    return;
  }

  window.launchQueue.setConsumer((launchParams) => {
    if (!launchParams.targetURL) {
      return;
    }

    const target = new URL(launchParams.targetURL, window.location.href);

    // Never follow a captured link off-origin.
    if (target.origin !== window.location.origin) {
      return;
    }

    const path = `${target.pathname}${target.search}${target.hash}`;

    if (path === router.currentRoute.value.fullPath) {
      return;
    }

    router.push(path);
  });
};
